import React from "react";
import "./App.scss";
import MainRouter from "./_routers/Router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Drawers from "./features/Drawers";
import SearchMenu from "./features/searchmenu/SearchMenu";

function App() {
  return (
    <>
      <ToastContainer />
      <SearchMenu />
      <Drawers />
      <MainRouter />
    </>
  );
}

export default App;
